import script from "./PolicyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyModal.vue?vue&type=script&setup=true&lang=js"

import "./PolicyModal.vue?vue&type=style&index=0&id=2c5951c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c5951c2"]])

export default __exports__